import axios from 'axios';
import { publicAPI } from 'services/api/apiUrl';

export const getProducts = (deliveryZoneId) =>
  axios({
    method: 'get',
    url: `${publicAPI}/product`,
    params: {deliveryZoneId}
  });
